import type { Decimal } from '@snap-types/types/decimal';

export function commaSeparatedString(
  input: Decimal,
  options?: Omit<Intl.NumberFormatOptions, 'useGrouping'>,
): string {
  const formatter = new Intl.NumberFormat('en-US', {
    useGrouping: true,
    ...options,
  });

  // This type assertion is a-okay because this type is just `${number}`
  // and Decimal's toFixed function is guaranteed to return in that format.
  return formatter.format(input.toFixed() as Intl.StringNumericLiteral);
}

export function currencyString(
  input: Decimal,
  options?: Omit<
    Intl.NumberFormatOptions,
    'style' | 'currency' | 'maximumFractionDigits'
  >,
): string {
  const formatter = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 100,
    ...options,
  });

  // This type assertion is a-okay because this type is just `${number}`
  // and Decimal's toFixed function is guaranteed to return in that format.
  return formatter.format(input.toFixed() as Intl.StringNumericLiteral);
}

export function decimalPercentString(
  input: Decimal,
  options?: Omit<Intl.NumberFormatOptions, 'style' | 'maximumFractionDigits'>,
): string {
  const formatter = Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: 100,
    ...options,
  });

  // This type assertion is a-okay because this type is just `${number}`
  // and Decimal's toFixed function is guaranteed to return in that format.
  return formatter.format(input.toFixed() as Intl.StringNumericLiteral);
}

export function percentString(
  input: Decimal,
  options?: Parameters<typeof decimalPercentString>[1],
): string {
  return decimalPercentString(input.div(100), options);
}
